export default {
  calendar: {
    today: 'Tänään',
    tomorrow: 'Huomenna',
    asap: 'Heti',
  },
};
